module.exports = __webpack_public_path__ + "img/feelIt.e7751624.png";